module.exports = __webpack_public_path__ + "static/img/traffic.64918cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/traffic.png
// module id = 8H6A
// module chunks = 1